import React from "react";
import InfoIcon from "../../../../assets/icons/info";

// shows class and description of the selected object
const GOIDetailsSection = ({ data }) => {
  // Destructure data for cleaner code
  const { id, class: className, classDescription, attrDescription } = data;

  return (
    <div className="goi-header-rules-section-wrapper">
      <details>
        <summary>Class</summary>
        <div className="goi-header-rules-section-wrapper-inner" id={id}>
          <p id={id}>{className} </p>
          <div className="goi-rules-section-tooltip">
            <InfoIcon />
            <span className="goi-rules-section-tooltiptext">
              {classDescription}
            </span>
          </div>
        </div>
      </details>

      <details>
        <summary>Description</summary>
        <div className="goi-header-rules-section-wrapper-inner" id={id}>
          <p id={id}>{attrDescription} </p>
        </div>
      </details>
      
      <details>
        <summary>ID</summary>
        <div className="goi-header-rules-section-wrapper-inner" id={id}>
          <p id={id}>{id}</p>
        </div>
      </details>
    </div>
  );
};

export default GOIDetailsSection;
